import HundredBricksAPIError from '../../../HundredBricksAPIError';
class ProfilerAnswerError extends HundredBricksAPIError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        super('ProfilerAnswerError', ...args);
    }
}
export default ProfilerAnswerError;
